module.exports = __webpack_public_path__ + "static/media/addFile.6191bc29.svg";